<template>
  <div class="md-card md-card-profile" :class="{ 'md-card-hidden': cardHidden }">
    <div class="md-card-header">
      <div class="md-card-avatar">
        <slot name="imageProfile"></slot>
      </div>
    </div>

    <div class="md-card-content">
      <slot name="title"></slot>
      <slot name="content"></slot>
    </div>

    <div class="md-card-actions">
      <slot name="footer"></slot>
    </div>
  </div>
</template>

<script>
export default {
  name: "lock-card",
  props: {
    imageProfile: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      cardHidden: true,
    };
  },
  beforeMount() {
    setTimeout(this.showCard, 400);
  },
  methods: {
    showCard: function () {
      this.cardHidden = false;
    },
  },
};
</script>

<style lang="css"></style>
